import { Component } from '@angular/core';

@Component({
  selector: 'district-footer',
  template: `
  <hr>
  <footer>
  </footer>`
})

export class FooterComponent {
  today: number;
  constructor() {
    this.today = Date.now();
  }
}
